import React, { useEffect, useState, useCallback } from "react";
import { useDropzone } from 'react-dropzone';
import { useTranslation } from "react-i18next";

const PdfUpload = ({ title = 'Pdfs', pdfs, setPdfs, label, maxSize = 1, setPdfFileNames }) => {

    const [addEnabled, setAddEnabled] = useState(true);
    const { t } = useTranslation();

    useEffect(() => {
        if (maxSize && pdfs.length === maxSize) {
            setAddEnabled(false);
        } else {
            setAddEnabled(true);
        }
    }, [pdfs]);

    const onDrop = useCallback((selectedFiles) => {
        const selectedFilesArray = Array.from(selectedFiles);
        const pdfsArray = selectedFilesArray.map((file) => {
            return URL.createObjectURL(file);
        });

        setPdfs((previousPdfArray) => previousPdfArray.concat(pdfsArray));
        setPdfFileNames(selectedFiles);
    }, [setPdfs]);

    const { getRootProps, getInputProps, isDragActive } = useDropzone({
        onDrop,
        accept: {
            'application/pdf': ['.pdf']
        },
        multiple: false,
        maxFiles: 1,
    });

    return (
        <div className="flex items-center justify-start gap-2 w-full">

            <label className="block text-sm font-medium leading-6 text-gray-900  min-w-24 mr-1">{title}</label>

            <div className="relative block w-full rounded-lg border-2 border-dashed border-gray-300 px-12 py-6 text-center hover:border-gray-400 hover:cursor-pointer focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 flex gap-4 items-center justify-center">
                {addEnabled && (
                    <div {...getRootProps()} className="block text-sm font-semibold">
                        <input {...getInputProps()} id={`${label.toLowerCase()}-pdf-upload`} name="pdfs" />
                        {isDragActive ? (
                            <span className="text-[var(--PrimaryColor)]">{t('dragNDropFileHere')} </span>
                        ) : (
                            <span className="text-[var(--PrimaryColor)]">{t('dragNDropFileHere')} <br />
                                {t('or')} <br />
                                {t('clickToSelectFiles')}
                            </span>
                        )}
                    </div>
                )}

                {pdfs.length > 0 &&
                    <div className="block text-sm font-semibold flex flex-col gap-4 items-center justify-center">
                        {pdfs.length >= maxSize && (
                            <span className="text-[var(--tiger-lilly)]">
                                Can't upload more than {maxSize} {maxSize > 1 ? 'PDFs' : 'PDF'}! <br />
                                {pdfs.length > maxSize && <span>
                                    Please delete <b>{pdfs.length - maxSize}</b> of them.
                                </span>}
                            </span>
                        )}

                        <span className="text-[var(--SecondaryColor)]">
                            Total {pdfs.length} PDF{pdfs.length === 1 ? '' : 's'}
                        </span>
                    </div>
                }
            </div>

        </div >
    )
}

export default PdfUpload;
